import './LoadingSpinner.css';

function LoadingSpinner() {
    return (
        <div className="loader"></div>
    );
}

export default LoadingSpinner;